import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  GetEquifaxPDFService,
  fetchStateService,
  downloadEquifaxPDF,
} from "../../../Services/CreditScorePDF/CreditScorePdf";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { getServiceNameAndDetails } from "../../../Services";

const EquifaxPdfUrl = () => {
   const endPoint = "/srv2/credit-report/equifax-pdf";
      const [serviceName, setServiceName] = useState("");
  const [cusName, setCusName] = useState("");
  const [dob, setDob] = useState("");
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [Gender, setGender] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
  const [profileData, setProfileData] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [statesList, setStatesList] = useState([]);
  const [Address, setAddress] = useState("");
  const [State, setState] = useState("");
  const [Pincode, setPincode] = useState("");
  const [pdfUrl, setPdfUrl] = useState(""); // Store PDF URL from response

  const maxScore = 900;

  const validateForm = () => {
    const newErrors = {};

    if (!cusName) {
      newErrors.cusName = "Customer name is required.";
    }

    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (panNo === "") {
      newErrors.panNo = "PAN number is required.";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase())) {
      newErrors.panNo = "Enter a valid PAN number (e.g., ABCDE1234F).";
    }

    if (!Gender) {
      newErrors.Gender = "Gender is required.";
    }

    if (!dob) {
      newErrors.dob = "Date of birth is required.";
    }

    if (!Address) {
      newErrors.Address = "Address is required.";
    }

    if (!State) {
      newErrors.State = "State is required.";
    }

    if (!Pincode) {
      newErrors.Pincode = "Pincode is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      const isValid = validateForm();
      if (!isValid) {
        setPdfUrl("");
        setCreditScore(0);
        showErrorToast("Please correct the form errors.");
        return;
      }

      setShowLoader(true);
      await addEquifaxPdf();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false);
    }
  };

  // View PDF in new tab
  const handleViewPDF = () => {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    } else {
      showErrorToast("No PDF URL available");
    }
  };

  // Update handleDownloadPDF
  const handleDownloadPDF = async () => {
    if (!pdfUrl) {
      showErrorToast("No PDF URL available");
      return;
    }

    try {
      setIsLoading(true);

      const blob = await downloadEquifaxPDF(pdfUrl);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Equifax_Report_${Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showSuccessToast("PDF downloaded successfully");
    } catch (error) {
      console.error("Error downloading PDF:", error);
      showErrorToast("Failed to download PDF");
    } finally {
      setIsLoading(false);
    }
  };

  async function addEquifaxPdf() {
    try {
      setShowLoader(true);
      setIsLoading(true);

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        name: cusName,
        mobile: mobile,
        pan: panNo,
        gender: Gender,
        dob: dob,
        address: Address,
        state: State,
        pincode: Pincode,
        consent: "Y",
      };

      const response = await GetEquifaxPDFService(payload);

      // console.log("res",response);
      const statusCode =
        response?.data?.status?.code ||
        response?.status?.code ||
        response?.status;

      const message =
        response?.data?.status?.message ||
        response?.data?.message ||
        response?.status?.message ||
        response?.message;

      if (statusCode === 403) {
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (statusCode === 422) {
        if (message === "Insufficient balance in api user wallet.") {
          showErrorToast("Insufficient balance in api user wallet.");
        } else if (message === "User not authorized to access this service.") {
          showErrorToast("User not authorized to access this service.");
        } else {
          showErrorToast(message || "Validation error");
        }
        return;
      }

      if (statusCode === 200) {
        // Extract PDF URL and credit score from response
        const reportUrl =
          response?.data?.report_url || response?.data?.data?.report_url;
        const score = response?.data?.credit_score || 0; // Handle null score

        setPdfUrl(reportUrl);
        setCreditScore(score);

        // Clear form
        setCusName("");
        setMobile("");
        setPanNo("");
        setGender("");
        setDob("");
        setAddress("");
        setState("");
        setPincode("");

        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Report generated successfully.",
        );
      } else {
        setPdfUrl("");
        showErrorToast(
          response?.data?.message ||
            response?.message ||
            "Something went wrong.",
        );
      }
    } catch (error) {
      console.error("Error in Equifax PDF:", error);
      setPdfUrl("");
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  useEffect(() => {
    async function fetchStates() {
      try {
        const response = await fetchStateService();
        setStatesList(response.data || []);
      } catch (error) {
        console.error("Error fetching states", error);
      }
    }
    fetchStates();
  }, []);


    useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading={serviceName} />

      <DivTag className="container grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-1 md:gap-2 p-2 justify-center bg-white md:mt-1 mt-0 shadow-blue-600 rounded-md">
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            value={cusName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter First Name"
            onChange={(e) => setCusName(e.target.value)}
          />
          {errors.cusName && (
            <p className="text-red-600 text-sm font-mono">{errors.cusName}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Mobile<strong className="text-red-700">*</strong>
          </HeadTag>
          <InputField
            type="text"
            placeholder="Enter Mobile"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          {errors.mobile && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.mobile}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            DOB<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="date"
            value={dob}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            onChange={(e) => setDob(e.target.value)}
          />
          {errors.dob && (
            <p className="text-red-600 text-sm font-mono">{errors.dob}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Pan No.<strong className="text-red-700">*</strong>
          </HeadTag>
          <InputField
            type="text"
            placeholder="Enter Pan"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
          />
          {errors.panNo && (
            <p className="text-red-600 text-sm font-mono">{errors.panNo}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Gender<strong className="text-red-700">*</strong>
          </HeadTag>
          <select
            value={Gender}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            onChange={(e) => setGender(e.target.value)}
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          {errors.Gender && (
            <p className="text-red-600 text-sm font-mono">{errors.Gender}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Address<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            value={Address}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Address"
            onChange={(e) => setAddress(e.target.value)}
          />
          {errors.Address && (
            <p className="text-red-600 text-sm font-mono">{errors.Address}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            State<strong className="text-red-700">*</strong>
          </HeadTag>
          <select
            value={State}
            onChange={(e) => setState(e.target.value)}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
          >
            <option value="">Select State</option>
            {statesList.map((state) => (
              <option key={state.id} value={state.abbreviation}>
                {state.state_name}
              </option>
            ))}
          </select>
          {errors.State && (
            <p className="text-red-600 text-sm font-mono">{errors.State}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Pincode<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            value={Pincode}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Pincode"
            onChange={(e) => setPincode(e.target.value)}
          />
          {errors.Pincode && (
            <p className="text-red-600 text-sm font-mono">{errors.Pincode}</p>
          )}
        </DivTag>
      </DivTag>

      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-8 mb-3 h-8 px-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Get Score"}
        </button>
      </div>

      {pdfUrl && ( // Remove creditScore > 0 condition
        <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <h2 className="text-xl md:text-xl font-semibold text-center">
            Your Equifax Credit Report
          </h2>

          <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            {creditScore > 0 ? ( // Show gauge only if score exists
              <div className="w-full md:w-[400px] relative md:mt-10">
                <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">
                  Poor
                </span>
                <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">
                  Average
                </span>
                <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">
                  Good
                </span>
                <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">
                  Excellent
                </span>

                <GaugeChart
                  id="gauge-chart1"
                  nrOfLevels={3}
                  percent={creditScore / maxScore}
                  needleColor={"#00008b"}
                  textColor={"transparent"}
                  needleBaseColor={"red"}
                  arcsLength={[0.3, 0.3, 0.3, 0.3]}
                  colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
                />
                <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
                  {creditScore}
                </p>
              </div>
            ) : (
              <div className="text-center text-gray-600 text-lg">
                Report generated successfully. Credit score not available.
              </div>
            )}

            <div className="flex flex-col items-center md:items-start">
              <div className="flex space-x-2 mt-4">
                <button
                  onClick={handleViewPDF}
                  className="bg-blue-600 text-white text-sm md:text-base rounded-md px-4 py-2 hover:bg-blue-700"
                >
                  View PDF
                </button>

                {/* <button
            className="bg-green-600 text-white text-sm md:text-base rounded-md px-4 py-2 hover:bg-green-700"
            onClick={handleDownloadPDF}
            disabled={isLoading}
          >
            {isLoading ? "Downloading..." : "Download PDF"}
          </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EquifaxPdfUrl;
